import ApiService from '@/core/services/ApiService';
import { getDataClient } from '@/core/services/JwtService';


export const getBanners = async (banner="", type="")=> {
  try {
    const {data} = await ApiService.get('/vehicles/banners/site?banner='+banner+'&type='+type);
    return data.data;
  } catch (error) {
    return null;
  }
}

export { buildTokenRequestConfig } from './BusTokenRequestConfig';

//conatct lead sales force 


export const getAccessToken = async () => {
  try { return await ApiService.getFreshBusToken(); }
  catch (_) { return null; }
};

export const getProfile = async () => {
  try {
    const token: any = localStorage.getItem("user");
    const infoUser = getDataClient(token);
    const { data }: any = await ApiService.get(`/seguridad/customers/${infoUser.uuid}`);
    const [dataUser] = data.data;
    return dataUser;
  } catch (error) {
    return null;
  }
}

const editProfile = async (values) => {
  try {
    const token: any = localStorage.getItem("user");
    const infoUser = getDataClient(token);
    await ApiService.put(
      `/seguridad/customers/${infoUser.uuid}`,
      values,
      true
    );
    return false;
  } catch (error) {
    return true;
  }
};

export const updateProfile = async (dataProfile, updateData) => {
  // Validar que dataProfile no sea null o undefined
  if (!dataProfile) {
    console.error('updateProfile: dataProfile is null or undefined');
    return { error: true, message: 'Perfil de usuario no disponible' };
  }

  let dataEdit = {};
  const phoneEmpty = !dataProfile.phone;
  const rfcEmpty = !dataProfile.rfc;
  const plast_nameEmpty = !dataProfile.plast_name;
  const alast_nameEmpty = !dataProfile.alast_name;

  Object.keys(updateData).forEach((key) => {
    if (updateData[key] != dataProfile[key]) {
      dataEdit = {
        ...dataEdit,
        [key]: updateData[key],
      };
    }
  });

  const dataLengthUpdate = Object.keys(dataEdit).length;

  if (dataLengthUpdate === 0) {
    return { ...dataEdit, update: false };
  } else {
    const {
      phone,
      cp,
      email_verified_at,
      mail,
      phone_prefix,
      alast_name,
      rfc,
      plast_name,
      ...res
    } = dataProfile;

    let error = false;

    dataProfile = { ...res };

    if (updateData.alast_name)
      dataProfile = {
        ...res,
        alast_name: alast_nameEmpty ? updateData.alast_name : alast_name,
      };

    if (updateData.rfc) {
      dataProfile = {
        ...dataProfile,
        rfc: rfcEmpty ? updateData.rfc : rfc,
      };
    }

    if (phoneEmpty || (rfcEmpty && updateData.rfc) || plast_nameEmpty) {
      dataProfile = {
        ...dataProfile,
        telephone: phoneEmpty ? `52 ${updateData.phone}` : `52 ${phone}`,
        plast_name: plast_nameEmpty ? updateData.plast_name : plast_name,
      };

       error = await editProfile(dataProfile);
     

      if (phoneEmpty) {
        delete dataEdit["phone"];
      }
      if (rfcEmpty && updateData.rfc) {
        delete dataEdit["rfc"];
      }
      if (plast_nameEmpty) {
        delete dataEdit["plast_name"];
      }

      return { ...dataEdit, update: Object.keys(dataEdit).length, error};
    } else {
      return { ...dataEdit, update: Object.keys(dataEdit).length };
    }
  }
};
  
